import React from "react";
//PrimeReact Components
import * as pr from "../../../common/PrimeComponents";
import { CrudlStatus } from "../../../common/config/AppConstants";
import { BPMInput } from "../../Common/BPMInput";
import * as format from "../../../common/FormatFunctions";
import { ListValueGenerator } from "../../Common/ListValueGenerator";
import { LoadScreen } from "../../Common/LoadScreen";
export class CustomerCard extends React.Component {
  state = {
    activeIndex: 0,
    editAddress: false,
    orders: [
      {
        description: "Test Order",
        purchaseOrderNumber: "737563",
        clientReference: "103758",
        shipTogether: "yes",
        status: "COMPLETE",
        orderDate: "24/01/2020"
      }
    ],
    deliveries: [
      {
        deliveryNumber: "876744",
        deliveryDate: "24/01/2020",
        deliveredBy: "John",
        dispatchDocketNumber: "428023",
        deliveryDocketNumber: "585858"
      }
    ],
    locationTree: [
      {
        key: "0",
        data: {
          name: "Main Site",
          addressLine1: "22 Test Lane",
          addressLine2: "test",
          city: "Magherafelt",
          postcode: "BT45 7UI"
        },
        children: [
          {
            key: "0-0",
            data: {
              name: "Southeast Wing"
            },
            children: [
              {
                key: "0-0-0",
                data: {
                  name: "Primary Building"
                },
                children: []
              }
            ]
          }
        ]
      }
    ]
  };

  render() {
    return (
      <React.Fragment>
        <pr.ScrollPanel
          ref={el => (this.layoutMenuScroller = el)}
          style={{ height: "85%", borderColor: "transparent" }}
        >
          <div className="ui-g">
            <h2>
              {format.capitalize(this.props.crudlState.display) + " Customer"}
            </h2>
            <div className="ui-g-12"></div>
            {this.props.loading === true && <LoadScreen />}
            {this.props.loading !== true && (
              <React.Fragment>
                <div className="ui-g-6 card-round">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Customer No</label>
                    </div>
                    <div className="ui-g-9">
                      <label className="input-label">
                        {format.formatId(this.props.editedObject.id)}
                      </label>
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Customer Name</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.businessName}
                        onChange={e => {
                          this.props.updateValue(
                            "businessName",
                            e.target.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  {!this.state.editAddress ? (
                    <div className="ui-g-12">
                      <div className="ui-g-3">
                        <label className="input-label">
                          Default Customer Address
                        </label>
                      </div>
                      <div className="ui-g-9">
                        <textarea
                          disabled={true}
                          rows={5}
                          placeholder=""
                          value={
                            this.props.editedObject.addressLine1 +
                            "\n" +
                            this.props.editedObject.addressLine2 +
                            "\n" +
                            this.props.editedObject.city +
                            "\n" +
                            this.props.editedObject.postalZipCode
                          }
                          style={{
                            width: "100%",
                            backgroundColor: "transparent"
                          }}
                        />
                        <pr.Button
                          label="Edit"
                          onClick={() => {
                            this.setState({
                              editAddress: !this.state.editAddress
                            });
                          }}
                          style={{ float: "right" }}
                        />
                      </div>
                    </div>
                  ) : (
                    <React.Fragment>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">Address Line 1</label>
                        </div>
                        <div className="ui-g-9">
                          <pr.InputText
                            //required={true}
                            value={this.props.editedObject.addressLine1}
                            onChange={e => {
                              this.props.updateValue(
                                "addressLine1",
                                e.target.value
                              );
                            }}
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">Address Line 2</label>
                        </div>
                        <div className="ui-g-9">
                          <pr.InputText
                            //required={true}
                            value={this.props.editedObject.addressLine2}
                            onChange={e => {
                              this.props.updateValue(
                                "addressLine2",
                                e.target.value
                              );
                            }}
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">City</label>
                        </div>
                        <div className="ui-g-9">
                          <pr.InputText
                            //required={true}
                            value={this.props.editedObject.city}
                            onChange={e => {
                              this.props.updateValue("city", e.target.value);
                            }}
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <div className="ui-g-3">
                          <label className="input-label">Postcode</label>
                        </div>
                        <div className="ui-g-9">
                          <pr.InputText
                            //required={true}
                            value={this.props.editedObject.postalZipCode}
                            onChange={e => {
                              this.props.updateValue(
                                "postalZipCode",
                                e.target.value
                              );
                            }}
                            disabled={
                              this.props.crudlState === CrudlStatus.VIEW
                            }
                          />
                        </div>
                      </div>
                      <div className="ui-g-12">
                        <pr.Button
                          label="Cancel"
                          onClick={() => {
                            this.setState({
                              editAddress: !this.state.editAddress
                            });
                          }}
                          style={{ float: "right" }}
                        />
                      </div>
                    </React.Fragment>
                  )}
                </div>

                <div className="ui-g-6 card-round">
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">
                        Customer Description
                      </label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.businessDescription}
                        onChange={e => {
                          this.props.updateValue(
                            "businessDescription",
                            e.target.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Email</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.email}
                        onChange={e => {
                          this.props.updateValue("email", e.target.value);
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                  <div className="ui-g-12">
                    <div className="ui-g-3">
                      <label className="input-label">Telephone</label>
                    </div>
                    <div className="ui-g-9">
                      <pr.InputText
                        //required={true}
                        value={this.props.editedObject.telephoneNumber}
                        onChange={e => {
                          this.props.updateValue(
                            "telephoneNumber",
                            e.target.value
                          );
                        }}
                        disabled={this.props.crudlState === CrudlStatus.VIEW}
                      />
                    </div>
                  </div>
                </div>

                <div className="ui-g-12">
                  <pr.TabView
                    activeIndex={this.state.activeIndex}
                    onTabChange={e => this.setState({ activeIndex: e.index })}
                  >
                    <pr.TabPanel header="Orders">
                      <pr.DataTable
                        value={this.state.orders}
                        selectionMode="single"
                        onSelectionChange={() => {}}
                        header="Orders"
                        emptyMessage="No orders"
                        rows={100}
                        autoLayout={true}
                        paginator={true}
                        alwaysShowPaginator={true}
                        responsive={true}
                      >
                        <pr.Column
                          field="description"
                          header="Description"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="purchaseOrderNumber"
                          header="Purchase Order No."
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="clientReference"
                          header="Client Reference"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="shipTogether"
                          header="Ship Together"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="status"
                          header="Status"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="orderDate"
                          header="Order Date"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                      </pr.DataTable>
                    </pr.TabPanel>
                    <pr.TabPanel header="Deliveries">
                      <pr.DataTable
                        value={this.state.deliveries}
                        selectionMode="single"
                        onSelectionChange={() => {}}
                        header="Deliveries"
                        emptyMessage="No deliveries"
                        rows={100}
                        autoLayout={true}
                        paginator={true}
                        alwaysShowPaginator={true}
                        responsive={true}
                      >
                        <pr.Column
                          field="deliveryNumber"
                          header="Delivery No."
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="deliveryDate"
                          header="Delivery Date"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="deliveredBy"
                          header="Delivered By"
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="dispatchDocketNumber"
                          header="Dispatch Docket No."
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                        <pr.Column
                          field="deliveryDocketNumber"
                          header="Delivery Docket No."
                          sortable={true}
                          filter={true}
                          filterMatchMode="contains"
                          style={{ overflow: "auto" }}
                        />
                      </pr.DataTable>
                    </pr.TabPanel>
                    <pr.TabPanel header="Locations">
                      <pr.TreeTable
                        value={this.state.locationTree}
                        header="Locations"
                        footer="&nbsp;"
                      >
                        <pr.Column field="name" header="Name" expander />
                        <pr.Column
                          field="addressLine1"
                          header="Address Line 1"
                        />
                        <pr.Column
                          field="addressLine2"
                          header="Address Line 2"
                        />
                        <pr.Column field="city" header="City" />
                        <pr.Column field="postcode" header="Postcode" />
                      </pr.TreeTable>
                    </pr.TabPanel>
                  </pr.TabView>
                </div>
              </React.Fragment>
            )}
          </div>
        </pr.ScrollPanel>

        <div className="Container">
          <pr.Toolbar
            className="bottom-bar"
            style={{
              backgroundColor: "transparent",
              borderColor: "transparent"
            }}
          >
            <div className="p-toolbar-group-left">
              <pr.Button
                icon="pi pi-times"
                label={"Cancel"}
                className="p-button-danger"
                style={{
                  marginRight: ".25em",
                  float: "left",
                  backgroundColor: "#043066"
                }}
                onClick={() => {
                  this.props.validateChanges();
                }}
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-trash"
                }
                label={"Delete"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.DELETE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState !== CrudlStatus.CREATE &&
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save"}
                onClick={e => {
                  this.props.crudlExecute(true);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                disabled={this.props.checkRequiredFields()}
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-save"
                }
                label={"Save and Close"}
                onClick={() => {
                  this.props.crudlExecute(false);
                }}
                style={
                  this.props.crudlState !== CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
              <pr.Button
                icon={
                  this.props.loading === true
                    ? "pi pi-spin pi-spinner"
                    : "pi pi-pencil"
                }
                label={"Edit"}
                onClick={() => {
                  this.props.crudlControl(
                    CrudlStatus.UPDATE,
                    this.props.editedObject
                  );
                }}
                style={
                  this.props.crudlState === CrudlStatus.VIEW
                    ? {
                        marginRight: ".25em",
                        float: "right",
                        backgroundColor: "#043066"
                      }
                    : { display: "none" }
                }
              />
            </div>
          </pr.Toolbar>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Customer/UI/CustomerCard.js